<!--
================================================
Un composant qui affiche une ligne de tableau d'un TaskTimerecord depuis le composant TimerecordsDetailedListComp

Ce composant est un fork de TaskTimerecordTableLineComp

url: http://localhost:8080/fr/rpvtest-inc/reports/detailed/start=/end=/cltArchShow=active/billable=?pjctArchShow=active

LIMITATIONS :

* l'affichage sur mobile n'afficeh pas les clients et isBIllable, car pour le moment je n'ai pas réussi à rendre le tableau bulma scrollable avec table-container (alors que j'ai réussi dans la liste des users).  Pour palier ce problème j'ai duppliqué l'affichage de la ligne projet dans la ligne task (redondant)

@deprecated @since @version 0.39.0 Remplacé par le taskTimerecordTableLineComp en mode readOnly
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template class="TimerecordReportTableLineComp" >


    <!-- ------------------------------------------>
    <!--    Timerecord de type isTask            -->
    <!-- ------------------------------------------>
    <tr class="tableLineContent" v-bind:class="[{'darkMode':themeToDisplay=='dark'}, 'detailTr_'+timerecord.slug]">

        <!--- TaskName--------------------------------------------->
        <td class="taskNameTd">
            <span>

                <!--- Task TR initial importicon--------------------------------------------->
                <span v-if="timerecord.isProjectInitialImport"
                      v-bind:id="'initialImportTr_'+timerecord.slug" class="initialImport">
                    <font-awesome-icon :icon="['fas', 'hourglass-half']" class="icon"/>
                </span>


                <!--TaskName------------------------------ ----------------------->

                <span class="taskName" >
                    {{timerecord.taskName}}
                </span>

                <span class="tag encours" v-if="timerecord.timeOut==null">{{$t('encours...')}}</span>

              <!-- REDONDANT : visible uniquement sur touch (@todo refactorer car redondant avec l'affichage dans projectTd)-->
              <span class="projectTouch is-hidden-desktop">
                  <span v-bind:title="$t('projet')" class="project">
                    <span v-if="timerecord.project !== null">
                      <font-awesome-icon v-bind:style="{color:'#'+ timerecord.project.color}" class="icon"
                                                   :icon="['far', 'folder-open']"/>
                      <span v-bind:class="'project project-'+timerecord.project.slug">{{ timerecord.project.name }}</span>
                  </span>
                </span>
              </span>
              <!-- FIN PARTIE REDONDANTE -->

            </span>
        </td>


        <td class="projectTd is-hidden-mobile has-text-left">
            <!--- Project--------------------------------------------->
            <span   v-bind:title="$t('projet')" class="project">
                <span v-if="timerecord.project !== null">
                                <font-awesome-icon v-bind:style="{color:'#'+ timerecord.project.color}" class="icon" :icon="['far', 'folder-open']"/>
                    <span v-bind:class="'project project-'+timerecord.project.slug" >{{timerecord.project.name}}</span>
                </span>
            </span>

            <!--- Client--------------------------------------------->
            <span   v-bind:title="$t('client')" class="client is-hidden-touch">
                <span v-if="timerecord.project !== null && timerecord.project.client !== null">
                    <font-awesome-icon :icon="['fas', 'user-tie']" class="icon"/>
                    <span v-bind:class="'client client-'+timerecord.project.client.slug" >{{timerecord.project.client.name}}</span>
                </span>
            </span>

            <!--- isBillable--------------------------------------------->
            <span class="isBillable" v-if="timerecord.isBillable">
                <span class="circle" v-bind:title="$t('facturable')">
                    <font-awesome-icon class="icon" :icon="['fas', 'dollar-sign']"/>
                </span>
            </span>
        </td>

        <!--- Durée--------------------------------------------->
        <td class="timesTd has-text-right">
            <span v-if="timerecord.timeOut!==null" v-bind:title="$t('durée')" class="duration">
                <font-awesome-icon :icon="['fas', 'stopwatch']" class="icon"/>
                <span v-if="timerecord.isProjectInitialImport" class="">{{durationInHours}}</span>
                <span v-else class="">{{duration}}</span>
            </span>

            <span v-if="timerecord.sProjectInitialImport!=true" class="is-hidden-mobile">
                <!--- TimeIn--------------------------------------------->
                <span  v-if="timerecord.timeOut!==null" v-bind:title="$t('dateDébut', {date: $moment(timerecord.timeIn).format('LLLL') })">
                    <span class="inconInOut in"></span>
                    <span class="time">{{timeIn}}</span>
                </span>

                <!--- TimeOut--------------------------------------------->
                <span v-if="timerecord.timeOut!==null" v-bind:title="$t('dateDeSortie', {date: $moment(timerecord.timeOut).format('LLLL') })" class="is-hidden-mobile">
                    <span class="inconInOut out"></span>
                    <span class="time">{{timeOut}}</span>
                </span>

            </span>
        </td>


        <!--- Icon edition--------------------------------------------->
<!--        <td class="trEdit is-hidden-mobile" v-bind:class="'tr_'+ timerecord.slug">-->
<!--            <a v-if="timerecord.timeOut != null" v-on:click="openModalTrEdit(timerecord)" v-bind:title="$t('modifierLePointage')" class="editIcon is-pulled-right">-->
<!--                <font-awesome-icon class="icon" :icon="['far', 'pencil-alt']"/>-->

<!--            </a>-->
<!--        </td>-->

    </tr>


</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import TimeMixin from "../../mixins/TimeMixin.js";

    export default {
        name: 'TimerecordReportTableLineComp', //utile dans vue dev tool
        mixins: [TimeMixin],
        // components: {},
        props: ['timerecord'],

        data: function () {
            return {

                locale : this.$route.params.locale,

                // pour les composants où l'user est identifié ///////////////////////
                // organizationSlug: this.$route.params.organization
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug)
                // componentIsReady : false, // indique quand le composant est prêt à être afficher
                // =================================================================
            }
        },
        computed:{
            ...mapState({
                user: state => state.user,
                currentTaskTr: state => state.TimeTrackingView.currentTaskTimerecord,
                themeToDisplay: state => state.app.themeToDisplay

            }),


            timeIn: {
                get: function () {
                    return this.$moment(this.timerecord.timeIn).tz(this.user.timezone).format('LT')
                },
            },
            timeOut: {
                get: function () {
                    return this.$moment(this.timerecord.timeOut).tz(this.user.timezone).format('LT')
                },
            },

            duration: {
                get: function () {
                    let duration = this.calculateDuration(this.$moment, this.timerecord.timeIn, this.timerecord.timeOut)

                    return this.formatDuration(duration,this.$moment, this.locale)
                },
            },

            durationInHours: {
                get: function () {
                    let duration = this.calculateDuration(this.$moment, this.timerecord.timeIn, this.timerecord.timeOut)
                    return this.formatDurationInHour(duration,this.$moment, this.locale)
                },
            }


        },


        methods: {
            // /**
            //  * Ouvre la Modal d'édition d'un task timerecord et prépare le timerecord dans le store
            //  * @param timerecord
            //  */
            // openModalTrEdit: function (timerecord) {
            //     this.$store.commit('UpdateModalTaskTimerecordsEditionComp', {isVisible: true, timerecord: timerecord,isCurrent:false})
            //
            // },


        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "../../assets/css/globalVar";
    @import "../../assets/css/bulmaResponsiveDep";


.tableLineContent{
  .icon{
    padding-top: 8px; // corrige alignement vertical
  }
  .time{
    /*font-weight: bold;*/
    color: #999;
    margin-right: 0.5rem;

  }
  .icon{
    margin-right: 0.4rem;
    /*border: darkgrey solid 1px;*/
    vertical-align: center;
    padding-top: 0px;
    $size: 0.9rem;
    width: $size;
    height: $size;
  }

  .iconContinueTask{
    $size: 3rem;
    width: $size;
    height: $size;
    padding: 0.5rem;
    /*background: red;*/
    border-radius: 3rem;
    /*display: inline-flex;*/
    /*position: relative;*/
    margin-right: 0.5rem;
    cursor: pointer;
    border: solid 1px #ccc;

    &:hover{
      border: solid 1px $brandPrimary;
      .icon{
        color: darken($brandPrimary,5%);
      }
    }
    &:active{
      box-shadow: 0 0 3px $brandPrimary;
      .icon{
        color: darken($brandPrimary,5%);
      }
    }

    .icon {
      /*background: #000;*/
      height: 0.6rem;
      width: 0.6rem;
      /*margin: 0 0 0 0.1rem;*/
      position: relative;
      left: 0.2rem;
      top: -0.1rem;


      /*width: 12px;*/
      color: #919290;
    }

  }
  .iconCurrentTask{
    $size: 3rem;
    width: $size;
    height: $size;
    padding: 0.5rem;
    border-radius: 3rem;

    @include mobile {
      $size: 2rem;
    }

    .icon {
      height: 1.2rem;
      width: 1.2rem;
      /*position: relative;*/
      color: #ddd;
    }

  }

  .taskNameTd{
    .projectTouch{
      display: block;
      padding-left: .3rem;
    }
  }
  .taskName {
    color: $taskColor;
    font-weight: bold;

    // limitation de la longeur d'affichage du nom de la  task
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /*max-width: 3rem;*/
    @include touch {
      max-width: 10rem;
      padding-left: .3rem;


    }



    a{
      color: $taskColor;

    }
    &.isCurrentTask{
      color: $brandSecondary;
      margin-right: 1rem;
    }




  }

  .isBillable {

    margin-left: 1rem;
    .circle {
      padding: 0.1rem 0.2rem;
      position: relative;

      /*background: #e9f4ce;*/
      border: solid 1px $brandPrimary;
      border-radius: 0.7rem;

      .icon {
        /*background: red;*/
        /*display: block;*/
        color: $brandPrimary;
        font-size: 1rem;
        margin: auto;
        /*background: #e9f4ce !important;*/
      }

    }
  }

  .inconInOut{

    display: inline-block;
    border: none;
    $size: 0.4rem;
    width: $size;
    height: $size;
    border-radius: 30px;
    margin-right: 0.3rem;

    &.in{
      background:$brandPrimary
    }
    &.out{
      background: $brandRed

    }
  }

  .duration{

    border-left: solid 1px #ddd;
    padding-left: 1rem;
    margin-right: 0.8rem;
    font-weight: bold;
    color: $brandFourth;
    .icon{
      color: #e2e6e7;
    }
  }

  .projectTd{

    .project{
      color:#777;
      font-weight: bold;
    }
    .client {
      color: $clientColor;
      margin-left: 1rem;
      font-weight: bold;
    }

  }

  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {
    .taskName{
      color:$darkContrastTxt !important;
    }
  }

}


</style>
